import React from 'react';
import IconFullScreen from '../../../../shared/ui/icons/IconFullScreen';
import s from './ToolsButtons.module.css';
import { useAppDispatch } from '../../../../store/store';
import { selectActivePrompt } from '../../../../store/selectors/pageSelectors';
import { toggleActivePrompt } from '../../../../store/slices/pageSlice';
import { useSelector } from 'react-redux';
import { BlockName } from '../../../../shared/types/projectTypes';
import { selectSelectedImage } from '../../../../store/selectors/imageSelectors';
const FullScreenButton = () => {
    const dispatch = useAppDispatch();
    const activePrompt = useSelector(selectActivePrompt);
    const selectedImage = useSelector(selectSelectedImage);
    const handleToggleBlock = (block: BlockName) => {
        dispatch(toggleActivePrompt(block));
    };
    if (!selectedImage.image?.id) {
        return null;
    }
    return (
        <button
            style={{
                width: '80px',
                fontSize: `${activePrompt === 'fullScreen' ? '10px' : '8px'}`,
            }}
            className={s.container}
            onClick={() => handleToggleBlock('fullScreen')}
        >
            <IconFullScreen width={18} height={18} />
            <p>{activePrompt === 'fullScreen' ? 'Exit-Screen' : 'Full Screen'}</p>
        </button>
    );
};

export default FullScreenButton;
